import { Select } from "@mantine/core";
import { useOperatorsQuery } from "../../hooks/useOperatorsQuery";
import { useUpdateFieldMutation } from "../../hooks/mutations";
import { buildFieldPutData } from "../../utils/conditionField";
import classes from "./ChangeOperator.module.scss";

const nonValueOperators = [
  "IS NOT NULL",
  "LIKE",
  "NOT LIKE",
  "IN",
  "NOT EMPTY",
  "NOT IN",
];

/**
 * Operator dropdown for a condition row (=, !=, >, contains, etc.).
 */
export default function ChangeOperator({ ruleId, fieldsData, canEdit = true }) {
  const { data: operatorsData } = useOperatorsQuery();
  const { mutate: updateField } = useUpdateFieldMutation({ ruleId });

  if (!fieldsData || !operatorsData) return null;

  const items = operatorsData.map((op) => op.value);
  const selectedValue = fieldsData?.operator?.value ?? "";

  const handleChange = (value) => {
    if (value == null) return;
    const operator = operatorsData.find((op) => op.value === value);
    const conditionOperatorType = operator?.type ?? null;

    const putData = {
      ...buildFieldPutData(fieldsData),
      conditionOperatorType,
    };

    putData.value = null;

    if (nonValueOperators.includes(conditionOperatorType)) {
      putData.type = "FIELD";
    } else {
      putData.type = "VALUE";
    }
    updateField(putData);
  };

  return (
    <Select
      data={items}
      value={selectedValue}
      onChange={handleChange}
      disabled={!canEdit}
      placeholder=""
      variant="unstyled"
      w={140}
      allowDeselect={false}
      className={classes.changeOperator}
    />
  );
}
